import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsStagesPlanWorksRecomendedCounterparties(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES,
		options
	)
}


export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES]: _getRegulationsStagesPlanWorksRecomendedCounterparties,
}
